import Plot from 'react-plotly.js';
import Plotly from "plotly.js-dist-min";
import { useEffect, useRef, useState } from 'react';
import SideChatPanel from './SideChatPanel';
import { getChartElementHistory } from '../services/chatService';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../redux/store';
import { setShowSidePanel } from '../redux/counterSlice';

// Attach Plotly engine
(Plot as any).plotly = Plotly;

export const ChartWrapper = ({ plotJson }: any) => {
    // if (!plotJson) return null;
    const dispatch = useDispatch<AppDispatch>();
    const figure = plotJson;
    const chartRef = useRef(null);
    // const [showSidePanel, setShowSidePanel] = useState(false);
    const [panelData, setPanelData] = useState<any>(null);
    // figure has keys: data (array) and layout (object)
    const plotData = figure?.data;
    const plotLayout = figure?.layout;
    const showSidePanel = useSelector((state: any) => state.counter.showSidePanel);
    // const layout = {
    //     "title": "World Map Example",
    //     "geo": {
    //         "scope": "world",
    //         "projection": { type: "natural earth" },
    //         "showframe": false,
    //         "landcolor": "#E5ECF6",
    //         "bgcolor": "rgba(0,0,0,0)",
    //         "domain": {
    //             "x": [
    //                 0,
    //                 1
    //             ],
    //             "y": [
    //                 0,
    //                 1
    //             ]
    //         },
    //         "center": {},
    //         "showcountries": true,
    //         "showcoastlines": true,
    //         "showland": true,
    //         "fitbounds": "locations",
    //     },
    //     "margin": { l: 0, r: 0, t: 0, b: 0 },
    //     "autosize": true,
    //     "height": 500,
    // }
    const cleanedLayout: any =
    plotLayout && typeof plotLayout === 'object'
      ? JSON.parse(JSON.stringify(plotLayout))
      : {};

    delete cleanedLayout.legend;
    // delete cleanedLayout.xaxis;
    // delete cleanedLayout.yaxis;
    // delete cleanedLayout.template; // <-- IMPORTANT FIX
    delete cleanedLayout.title; // <-- IMPORTANT FIX

    cleanedLayout.autosize = true;
    cleanedLayout.height = 500;

    useEffect(() => {
        if (!plotJson) return;
        if (!window.Plotly) return;
        if (!chartRef.current) return;
    
        // Deep clone to avoid mutating original
        const safeFig = JSON.parse(JSON.stringify(plotJson));
        const layout = safeFig.layout || {};
        delete layout.title;
    
        const plotElement: any = chartRef.current;
    
        const handleChartClick = async (eventData: any) => {
            // console.log('Chart Clicked!');
            // console.log('Click Event Data:', eventData);
            // console.log('Chart Data:', plotJson);
            // console.log('Full Chart Figure:', {
            //     data: plotJson?.data,
            //     layout: plotJson?.layout
            // });
    
            const isMap = plotJson?.layout?.geo ||
                plotJson?.layout?.mapbox ||
                (plotJson?.data && plotJson.data.some((trace: any) =>
                    trace.type === 'scattergeo' ||
                    trace.type === 'choropleth' ||
                    trace.type === 'scattermapbox'
                ));
    
            const isPieChart = plotJson?.data && plotJson.data.some((trace: any) => trace.type === 'pie');
    
            if (eventData && eventData.points && eventData.points.length > 0) {
                const point = eventData.points[0];
    
                const chartTitle = plotJson?.layout?.title?.text || plotJson?.layout?.title || '';
                const xAxisTitle = plotJson?.layout?.xaxis?.title?.text || plotJson?.layout?.xaxis?.title || '';
                const yAxisTitle = plotJson?.layout?.yaxis?.title?.text || plotJson?.layout?.yaxis?.title || '';
                const chartType = isMap ? 'map' : (isPieChart ? 'pie' :
                    (plotJson?.data?.[0]?.type || 'bar'));
    
                let panelDataToPass: any = {
                    title: 'Drill Down Analysis',
                    context: '',
                    history: [],
                    chart_type: chartType,
                    chart_title: chartTitle,
                    x_axis: xAxisTitle,
                    y_axis: yAxisTitle,
                    plotJson: plotJson
                };
    
                let chartConversationID = '';
    
                if (isMap) {
                    chartConversationID = point.location ? `map_${point.location}` :
                        (point.lat !== undefined && point.lon !== undefined ?
                            `map_${point.lat}_${point.lon}` :
                            `map_${JSON.stringify(point.customdata)}`);
    
                    panelDataToPass.customdata = point.customdata;
                    panelDataToPass.location = point.location;
    
                    const contextParts = [];
                    if (point.location) contextParts.push(`Location: ${point.location}`);
                    if (point.lat !== undefined && point.lon !== undefined) {
                        contextParts.push(`Coordinates: ${point.lat}, ${point.lon}`);
                    }
                    if (point.customdata) {
                        contextParts.push(`Data: ${JSON.stringify(point.customdata)}`);
                    }
                    panelDataToPass.context = contextParts.join(' | ') || 'Map data selected';
                } else if (isPieChart) {
                    chartConversationID = `pie_${point.label}_${point.value}`;
                    panelDataToPass.label = point.label;
                    panelDataToPass.value = point.value;
    
                    const contextParts = [];
                    if (point.label !== undefined) contextParts.push(`${point.label}`);
                    if (point.value !== undefined) contextParts.push(`${point.value}`);
                    panelDataToPass.context = contextParts.join(' | ') || 'Pie chart data selected';
                } else {
                    chartConversationID = `graph_${point.x}_${point.y}`;
                    panelDataToPass.x = point.x;
                    panelDataToPass.y = point.y;
    
                    const contextParts = [];
                    if (point.x !== undefined) contextParts.push(`X: ${point.x}`);
                    if (point.y !== undefined) contextParts.push(`Y: ${point.y}`);
                    panelDataToPass.context = contextParts.join(' | ') || 'Chart data selected';
                }
    
                panelDataToPass.chart_conversation_id = chartConversationID;
    
                try {
                    const userId = localStorage.getItem("user_id");
                    const sessionId = localStorage.getItem("session_id");
    
                    if (userId && sessionId) {
                        const { result, error } = await getChartElementHistory({
                            user_id: userId,
                            session_id: sessionId,
                            chart_conversation_id: chartConversationID,
                            page_no: 1,
                            page_size: 5
                        });
    
                        if (result && !error) {
                            if (Array.isArray(result) && result.length > 0) {
                                panelDataToPass.history = result;
                            } else if (result.history && Array.isArray(result.history) && result.history.length > 0) {
                                panelDataToPass.history = result.history;
                            }
                        }
                    }
                } catch (err) {
                    console.error('Error checking chart element history:', err);
                }
    
                setPanelData(panelDataToPass);
                dispatch(setShowSidePanel(true));
            }
        };
    
        const handleChartHover = (eventData: any) => {
            // optional: hover logging
        };
    
        window.Plotly
            .newPlot(plotElement, safeFig.data, layout, { responsive: true, displayModeBar: true })
            .then(() => {
                if (typeof plotElement.on === "function") {
                    plotElement.on("plotly_click", handleChartClick);
                    plotElement.on("plotly_hover", handleChartHover);
                }
            });
    
        return () => {
            if (plotElement && typeof plotElement.removeAllListeners === "function") {
                plotElement.removeAllListeners("plotly_click");
                plotElement.removeAllListeners("plotly_hover");
            }
        };
    }, [plotJson]);

    // Add click event listener to log chart data
    useEffect(() => {
        if (!chartRef.current) return;
        
        // const handleChartClick = async (eventData: any) => {
        //     console.log('Chart Clicked!');
        //     console.log('Click Event Data:', eventData);
        //     console.log('Chart Data:', plotJson);
        //     console.log('Full Chart Figure:', {
        //         data: plotJson?.data,
        //         layout: plotJson?.layout
        //     });
            
        //     // Check chart type
        //     const isMap = plotJson?.layout?.geo || 
        //                  plotJson?.layout?.mapbox || 
        //                  (plotJson?.data && plotJson.data.some((trace: any) => 
        //                      trace.type === 'scattergeo' || 
        //                      trace.type === 'choropleth' || 
        //                      trace.type === 'scattermapbox'
        //                  ));
            
        //     const isPieChart = plotJson?.data && plotJson.data.some((trace: any) => trace.type === 'pie');
            
        //     console.log('Chart Type:', isMap ? 'Map' : (isPieChart ? 'Pie Chart' : 'Regular Chart'));
            
        //     // Process click data and check history before opening side panel
        //     if (eventData && eventData.points && eventData.points.length > 0) {
        //         const point = eventData.points[0]; // Get first clicked point
                
        //         // Log all properties available in the point object
        //         console.log('Point - All Properties:', Object.keys(point).reduce((acc: any, key: string) => {
        //             acc[key] = point[key];
        //             return acc;
        //         }, {}));

        //         // Extract chart metadata from plotJson first
        //         const chartTitle = plotJson?.layout?.title?.text || plotJson?.layout?.title || '';
        //         const xAxisTitle = plotJson?.layout?.xaxis?.title?.text || plotJson?.layout?.xaxis?.title || '';
        //         const yAxisTitle = plotJson?.layout?.yaxis?.title?.text || plotJson?.layout?.yaxis?.title || '';
        //         const chartType = isMap ? 'map' : (isPieChart ? 'pie' : 
        //             (plotJson?.data?.[0]?.type || 'bar'));

        //         // Initialize panel data with base fields
        //         let panelDataToPass: any = {
        //             title: isMap ? 'Map Analysis' : (isPieChart ? 'Pie Chart Analysis' : 'Chart Analysis'),
        //             context: '',
        //             history: [],
        //             chart_type: chartType,
        //             chart_title: chartTitle,
        //             x_axis: xAxisTitle,
        //             y_axis: yAxisTitle,
        //             plotJson: plotJson // Pass full plotJson for additional metadata extraction
        //         };

        //         // Generate unique chart element ID based on chart type and clicked data
        //         let chartConversationID = '';
        //         if (isMap) {
        //             // For maps: use location or coordinates as ID
        //             chartConversationID = point.location ? `map_${point.location}` : 
        //                             (point.lat !== undefined && point.lon !== undefined ? 
        //                              `map_${point.lat}_${point.lon}` : 
        //                              `map_${JSON.stringify(point.customdata)}`);
        //             panelDataToPass.customdata = point.customdata;
        //             panelDataToPass.location = point.location;
                    
        //             // Build context string
        //             const contextParts = [];
        //             if (point.location) contextParts.push(`Location: ${point.location}`);
        //             if (point.lat !== undefined && point.lon !== undefined) {
        //                 contextParts.push(`Coordinates: ${point.lat}, ${point.lon}`);
        //             }
        //             if (point.customdata) {
        //                 contextParts.push(`Data: ${JSON.stringify(point.customdata)}`);
        //             }
        //             panelDataToPass.context = contextParts.join(' | ') || 'Map data selected';
                    
        //             console.log('Map clicked - Passing customdata and location:', {
        //                 customdata: point.customdata,
        //                 location: point.location
        //             });
        //         } else if (isPieChart) {
        //             // For pie charts: use label as ID
        //             chartConversationID = `pie_${point.label}_${point.value}`;
        //             panelDataToPass.label = point.label;
        //             panelDataToPass.value = point.value;
                    
        //             // Build context string
        //             const contextParts = [];
        //             if (point.label !== undefined) contextParts.push(` ${point.label}`);
        //             if (point.value !== undefined) contextParts.push(` ${point.value}`);
        //             panelDataToPass.context = contextParts.join(' | ') || 'Pie chart data selected';
                    
        //             console.log('Pie chart clicked - Passing label and value:', {
        //                 label: point.label,
        //                 value: point.value
        //             });
        //         } else {
        //             // For graphs: use x and y as ID
        //             chartConversationID = `graph_${point.x}_${point.y}`;
        //             panelDataToPass.x = point.x;
        //             panelDataToPass.y = point.y;
                    
        //             // Build context string
        //             const contextParts = [];
        //             if (point.x !== undefined) contextParts.push(`X: ${point.x}`);
        //             if (point.y !== undefined) contextParts.push(`Y: ${point.y}`);
        //             panelDataToPass.context = contextParts.join(' | ') || 'Chart data selected';
                    
        //             console.log('Graph clicked - Passing x and y:', {
        //                 x: point.x,
        //                 y: point.y
        //             });
        //         }

        //         // Add chart_conversation_id after it's generated
        //         panelDataToPass.chart_conversation_id = chartConversationID;

        //         // Check for history via API
        //         try {
        //             const userId = localStorage.getItem("user_id");
        //             const sessionId = localStorage.getItem("session_id");
                    
        //             if (userId && sessionId) {
        //                 console.log('Checking history for chart element:', chartConversationID);
        //                 const { result, error } = await getChartElementHistory({
        //                     user_id: userId,
        //                     session_id: sessionId,
        //                     chart_conversation_id: chartConversationID,
        //                     page_no: 1,
        //                     page_size: 5
        //                 });

        //                 if (result && !error) {
        //                     // If history exists, add it to panelData
        //                     if (Array.isArray(result) && result.length > 0) {
        //                         panelDataToPass.history = result;
        //                         console.log('History found for chart element:', result);
        //                     } else if (result.history && Array.isArray(result.history) && result.history.length > 0) {
        //                         panelDataToPass.history = result.history;
        //                         console.log('History found for chart element:', result.history);
        //                     } else {
        //                         console.log('No history found for chart element');
        //                     }
        //                 } else {
        //                     console.log('Error or no history:', error);
        //                 }
        //             }
        //         } catch (err) {
        //             console.error('Error checking chart element history:', err);
        //         }

        //         // Set panel data and show side panel (with or without history)
        //         setPanelData(panelDataToPass);
        //         dispatch(setShowSidePanel(true));
        //     }
        // };

        const handleChartHover = (eventData: any) => {
            // Optional: log on hover as well
            // console.log('Chart Hover:', eventData);
        };

        // Attach event listeners
        // if(chartRef.current){
        //     console.log("chartRef.current",chartRef.current)
        //     (chartRef.current as any).on('plotly_click', handleChartClick);
        //     (chartRef.current as any).on('plotly_hover', handleChartHover);
        // }
       

        // Cleanup: remove event listeners on unmount or when plotJson changes
        return () => {
            if (chartRef.current) {
                (chartRef.current as any).removeAllListeners('plotly_click');
                (chartRef.current as any).removeAllListeners('plotly_hover');
            }
        };
    }, [plotJson]);
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         const modebar = document.querySelector('.modebar.modebar--custom');

    //         if (modebar && !document.getElementById('my-custom-btn')) {

    //             const btn = document.createElement("button");
    //             btn.id = "my-custom-plotly-btn";
    //             btn.type = "button";

    //             // Same classes used by Plotly
    //             btn.className = "modebar-btn";
    //             btn.setAttribute("rel", "tooltip");
    //             btn.setAttribute("data-title", "Full Screen");
    //             btn.setAttribute("aria-label", "Full Screen");
    //             btn.setAttribute("data-toggle", "false");
    //             btn.setAttribute("data-gravity", "n");
    //             btn.setAttribute("data-btn-style-event-added", "true");
    //             btn.classList.add("custom-plotly-btn");
    //             // Insert SVG
    //             btn.innerHTML = `
    //             <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
    //                     xmlns="http://www.w3.org/2000/svg">
    //                     <path d="M5 15L9 11M5 15H9M5 15V11"
    //                         stroke="#97A0AF" stroke-width="1.6"
    //                         stroke-linecap="round" stroke-linejoin="round"/>
    //                     <path d="M15 5L11 9M15 5H11M15 5V9"
    //                         stroke="#97A0AF" stroke-width="1.6"
    //                         stroke-linecap="round" stroke-linejoin="round"/>
    //                 </svg>
    //         `;

    //             // add a click handler
    //             btn.onclick = () => {
    //                 console.log("Custom button clicked!");
    //             };

    //             // append at last OR choose insertBefore()
    //             modebar.appendChild(btn);

    //             clearInterval(interval);
    //         }
    //     }, 300);

    //     return () => clearInterval(interval);
    // }, [plotJson]);
    const handleClosePanel = () => {
        dispatch(setShowSidePanel(false));
        setPanelData(null);
    };

    const handleRestartPanel = () => {
        // Reset panel chat
        setPanelData(null);
        dispatch(setShowSidePanel(false));
    };

    // Close side panel when clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Check if side panel is open
            if (!showSidePanel) return;

            // Get the side panel element
            const sidePanelElement = document.getElementById('side-chat-panel');
            
            // Check if click is outside the side panel
            if (sidePanelElement && !sidePanelElement.contains(event.target as Node)) {
                // Close the panel
                dispatch(setShowSidePanel(false));
                setPanelData(null);
            }
        };

        // Add event listener when side panel is open
        if (showSidePanel) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        // Cleanup: remove event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showSidePanel, dispatch]);

    return (
        <>
        <div className="custom-card1">
            <div className="custom-card-inner">
                {/* <div style={{ textAlign: "right" }}>
                    <i style={{ marginRight: "4px", cursor: "pointer" }}>
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 3V13"
                                stroke="#637381"
                                stroke-width="1.6"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6 9L10 13L14 9"
                                stroke="#637381"
                                stroke-width="1.6"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M4 16H16"
                                stroke="#637381"
                                stroke-width="1.6"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </i>
                    <i style={{ cursor: "pointer" }}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 15L9 11M5 15H9M5 15V11"
                                stroke="#97A0AF"
                                stroke-width="1.6"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M15 5L11 9M15 5H11M15 5V9"
                                stroke="#97A0AF"
                                stroke-width="1.6"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </i>
                </div> */}
                <div 
                    style={{ height: 500, marginRight: '0px' }} 
                    ref={chartRef}
                    onClick={(e) => {
                        // // Log chart data on any click on the chart container
                        // console.log('Chart Container Clicked');
                        // console.log('Chart Data:', plotJson);
                        // console.log('Chart Figure:', {
                        //     data: plotJson?.data,
                        //     layout: plotJson?.layout
                        // });
                    }}
                >
                    {/* <Plot
                        // data={data}
                        data={cleanedData}
                        layout={cleanedLayout}
                        config={{ responsive: true }}
                        // layout={layout}
                        // layout={{ ...plotLayout, autosize: true }}
                        style={{ width: '100%', height: '100%' }}
                        useResizeHandler
                    /> */}
                    {/* <Plot
                data={[
                    {
                        "domain": {
                            "x": [
                                0,
                                1
                            ],
                            "y": [
                                0,
                                1
                            ]
                        },
                        "hovertemplate": "market_region=%{label}<br>sales_percentage=%{value}<extra></extra>",
                        "labels": [
                            "99 WEB",
                            "International",
                            "MDS",
                            "nan",
                            "NORTH-CENTRAL",
                            "NORTH-EAST",
                            "SOUTH",
                            "SOUTH-CENTRAL",
                            "SOUTH-EAST",
                            "WEST"
                        ],
                        "legendgroup": "",
                        "name": "",
                        "showlegend": true,
                        "values": [
                            13.7041482511,
                            1.9296331753,
                            1.8525366658,
                            0.008426656900000001,
                            17.530119506,
                            17.7821266123,
                            12.4539665524,
                            10.3073164988,
                            7.4918864071,
                            16.9398396744
                        ],
                        "type": "pie"

                    }
                ]}
                layout={{ title: {text: "Pie Chart: sales percentage by market region..."}, autosize: true }}
                useResizeHandler
                style={{ width: "100%", height: "400px" }}
            /> */}
                </div>
            </div>
        </div>
        {showSidePanel && panelData && (
            <SideChatPanel
                title={panelData.title}
                context={panelData.context}
                onClose={handleClosePanel}
                onRestart={handleRestartPanel}
                // customdata={panelData.customdata}
                location={panelData.location}
                x={panelData.x}
                y={panelData.y}
                label={panelData.label}
                value={(panelData.value)}
                initialHistory={panelData.history || []}
                chart_conversation_id=""
                // chart_conversation_id={panelData.chart_conversation_id}
                chart_type={panelData.chart_type}
                chart_title={panelData.chart_title}
                x_axis={panelData.x_axis}
                y_axis={panelData.y_axis}
                plotJson={panelData.plotJson}
            />
        )}
        </>
    );
};
